<template>
  <div class="baseshortcut" :class="{ 'is-actionable': isActionable }" @click="shorcutClicked">
    <div v-if="isIcon" class="baseshortcut__box">
      <BaseIcon :name="value" class="baseshortcut__icon" />
    </div>
    <BaseIcon v-else-if="isPlus" :name="value" class="baseshortcut__plus" />
    <div v-else class="baseshortcut__box">
      <span class="baseshortcut__text"
        ><kbd>{{ value }}</kbd></span
      >
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';

export default {
  name: 'BaseShortcut',
  components: { BaseIcon },
  props: {
    value: String,
    isIcon: {
      type: Boolean,
      default: false,
    },
    isPlus: {
      type: Boolean,
      default: false,
    },
    isActionable: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    shorcutClicked() {
      if (!this.isActionable) return;
      this.$emit('shortcut-clicked');
    },
  },
};
</script>

<style lang="scss">
.baseshortcut {
  display: inline-block;
  margin-left: 1px;
  margin-right: 1px;
  margin-top: 4px;

  &.is-actionable {
    margin: 0px;

    kbd {
      color: $color-normal;
      font-size: 16px;
    }

    .baseshortcut__box {
      cursor: pointer !important;
      background-color: transparent;
      transition: all 200ms ease;
      height: auto;
      padding: 4px 8px;

      &:hover {
        transition: all 200ms ease;
        background-color: $color-hover;
        color: $color-white;
      }
    }
  }

  &__box {
    border: 1px solid $color-normal-pale;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.6), 0 2px 0 0 rgba(255, 255, 255, 0.37) inset;
    background-color: $color-slate-800;
    border-radius: $border-radius-medium;
    height: 22px;
    color: $color-neutral-pale;
    display: inline-block;
    font-size: 0.85em;
    font-weight: 700;
    line-height: 1;
    padding: 4px;
    white-space: nowrap;
  }

  &__text {
    vertical-align: middle;
  }

  &__icon {
    height: 14px;
    padding: 0px;
    margin: 0px;
    vertical-align: middle;
  }

  &__plus {
    height: 12px;
    margin: -5px;
    vertical-align: middle;
  }
}
</style>
